import { CoreInput, CoreSelect, CoreSwitch } from '@components'
import CalendarIcon from '@images/icons/filter-calendar.svg?react'
import InfoIcon from '@images/icons/info-recurring.svg?react'
import InputCalendarIcon from '@images/icons/transaction-search-calendar.svg?react'
import { format } from 'date-fns'
import { tr } from 'mmfintech-commons'
import ReactTooltip from 'react-tooltip'

import './recurringToggleBox.scss'

const toDateOnly = (date: Date) => format(date, 'yyyy-MM-dd')

export const RECURRING_STEP_OPTIONS = [
  {
    get label() {
      return tr('FRONTEND.RECURRING.FREQUENCY_DETAILS.WEEKLY', 'Weekly')
    },
    value: 'WEEKLY'
  },
  {
    get label() {
      return tr('FRONTEND.RECURRING.FREQUENCY_DETAILS.BI_WEEKLY', 'Biweekly')
    },
    value: 'BI_WEEKLY'
  },
  {
    get label() {
      return tr('FRONTEND.RECURRING.FREQUENCY_DETAILS.MONTHLY', 'Monthly')
    },
    value: 'MONTHLY'
  },
  {
    get label() {
      return tr('FRONTEND.RECURRING.FREQUENCY_DETAILS.YEARLY', 'Yearly')
    },
    value: 'YEARLY'
  }
]

export const RecurringToggleBox = ({
  onToggle,
  isRecurringOpen,
  recurringDetailsFormValues
}: {
  onToggle: () => void
  isRecurringOpen: boolean
  recurringDetailsFormValues: any
}) => {
  const preparedToolTip = `<div>${tr(
    'FRONTEND.BANKING.SEND_MONEY.RECURRING.TOOLTIP',
    'Schedule automatic payments at regular intervals by choosing the amount, frequency, and start date.'
  )}</div>`

  return (
    <div className={`recurring-animation-container ${isRecurringOpen ? 'open' : ''}`}>
      <div className={`recurring-toggle-box-container `}>
        <div className='recurring-toggle-box-header'>
          <div className='recurring-toggle-box-header-title'>
            <CalendarIcon width={18} height={18} />
            <span>
              {tr('FRONTEND.RECURRING.TITLE', 'Schedule a recurring transfer')}{' '}
              <InfoIcon className='recurring-tooltip-icon' data-for='recurring-tooltip' data-tip={preparedToolTip} />
            </span>
          </div>
          <CoreSwitch
            isActive={isRecurringOpen}
            handleSwitch={() => {
              onToggle()
              recurringDetailsFormValues.setValue('recurringPlanName', '')
              recurringDetailsFormValues.setValue('startDate', toDateOnly(new Date()))
              recurringDetailsFormValues.setValue('recurringStep', '')
            }}
          />
        </div>
        <CoreInput
          name='recurring-plan-name'
          label={tr('FRONTEND.BANKING.SEND_MONEY.RECURRING.PLAN_NAME', 'Recurring plan name')}
          className='recurring-plan-name-input'
          {...recurringDetailsFormValues.registerInput('recurringPlanName')}
          onChange={(_, value) => {
            return recurringDetailsFormValues.setValue('recurringPlanName', value)
          }}
        />

        <div className='recurring-content'>
          <div className='date-container'>
            <div className='date-container-title'>
              <span>{tr('FRONTEND.BANKING.SEND_MONEY.RECURRING.DATE', 'Date')}</span>
            </div>
            <CoreInput
              type='date'
              name='from'
              label={tr('FRONTEND.CRYPTO.BUY.FROM', 'From')}
              LeftIcon={<InputCalendarIcon />}
              className='transaction-calendar-input'
              {...recurringDetailsFormValues.registerInput('startDate')}
              onChange={(_, value: Date) => {
                return recurringDetailsFormValues.setValue('startDate', toDateOnly(value))
              }}
              minDate={toDateOnly(new Date())}
              data-test='recurring-date-input '
            />
          </div>
          <div className='frequency-container'>
            <div className='frequency-container-title'>
              <span>{tr('FRONTEND.BANKING.SEND_MONEY.RECURRING.FREQUENCY', 'Frequency')}</span>
            </div>
            <CoreSelect
              type='default'
              options={RECURRING_STEP_OPTIONS}
              {...recurringDetailsFormValues.registerInput('recurringStep')}
              onChange={(_, value) => {
                return recurringDetailsFormValues.setValue('recurringStep', value)
              }}
              name='from'
              label={tr('FRONTEND.BANKING.SEND_MONEY.RECURRING.SELECT_FREQUENCY', 'Select Frequency')}
              LeftIcon={<InputCalendarIcon />}
              className='transaction-calendar-input'
              data-test='recurring-frequency-select'
            />
          </div>
        </div>
        <ReactTooltip
          id='recurring-tooltip'
          place={'bottom'}
          html
          type='dark'
          arrowColor='transparent'
          className='recurring-tooltip'
          padding={'16px'}
        />
      </div>
    </div>
  )
}
